import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validator, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./login-forms.scss'],
  providers: [ AuthService ]
})
export class ForgotPasswordFormComponent {
  forgotPasswordForm: FormGroup;

  constructor (private authService: AuthService, private formBuilder: FormBuilder, private router: Router) {
    this.createForgotPasswordForm();
  }

  createForgotPasswordForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
    });
  }

  get email() {
    return this.forgotPasswordForm.get('email');
  }

  async forgotPassword() {
    try {
      await this.authService.forgotPassword(this.forgotPasswordForm.value.email);
      this.router.navigate(['/login', 'emailSent']);
    }
    catch (err) {
      this.router.navigate(['/login', 'emailSent']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/forms/forgot-password-form.component.ts